import * as React from "react";

type ImgProps = React.ComponentProps<"img">;

class Image extends React.Component<ImgProps> {
    imageRef: React.RefObject<HTMLImageElement>;

    constructor(props: ImgProps) {
        super(props);
        this.imageRef = React.createRef();
    }

    render() {
        return <img {...this.props} ref={this.imageRef} />;
    }
}

export default Image;
